import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getPlateOrders({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_PLATE_ORDERS_REQUEST')

        return axios
            .get(`/plate-orders/plate-orders${paginate}${query}`)
            .then(response => {
                commit('GET_PLATE_ORDERS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PLATE_ORDERS_FAILURE')
                handleApiError(error, 'Pobranie listy zamówień powiodło się.')

                return Promise.reject(error)
            })
    },
    getPlateOrder(context, id) {
        return axios
            .get(`/plate-orders/plate-order/${id}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych dla zamówienia ${id} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    getPlateOrderItem(context, id) {
        return axios
            .get(`/plate-orders/plate-order-item/${id}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych dla płyty ${id} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    updatePlateOrder({ commit }, plateOrderData) {
        return axios
            .put(`/plate-orders/plate-order/${plateOrderData.id}`, plateOrderData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zapis powiódł się.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis nie powiódł się.')

                return Promise.reject(error)
            })
    },
    deletePlateOrderItem({ commit }, id) {
        return axios
            .delete(`/plate-orders/plate-order-item/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Płyta została usunięta.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie płyty nie powiodło się.')

                return Promise.reject(error)
            })
    },
    turnSignalOff({ commit }) {
        return axios
            .post('/plate-orders/signaller-off')
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Alarm został wyłączony.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wyłączenie alarmu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setPlateOrdersFilters({ commit }, filters) {
        commit('SET_PLATE_ORDERS_FILTERS', filters)
    },
    clearPlateOrdersFilters({ commit }) {
        commit('CLEAR_PLATE_ORDERS_FILTERS')
    }
}